import styled, {css} from 'styled-components';
import {dFlex, dFlexCenter, dFlexColumn, justifyCenter} from '../../../../globalVariables/GlobalFlex';

export const row = styled.div`
    ${dFlex}
    ${justifyCenter}
    align-items: stretch;
    gap: var(--space-sm);
    width: 100%;
`;

export const tile = styled.div<{$flexible?: boolean}>`
    flex: none;
    min-width: 66px;
    min-height: 66px;
    ${dFlexColumn}
    align-items: center;
    gap: var(--space-xs);
    padding: var(--space-sm);
    background: var(--color-bg-base);
    border: 1px solid var(--color-border-subtle);
    border-radius: var(--border-radius-border-radius-md);
    ${({$flexible}) => $flexible && css`
        flex: 0 1 auto;
        max-width: 130px;
    `}
`;

export const valueArea = styled.div`
    flex: 1;
    min-height: 0;
    width: 100%;
    ${dFlexCenter}
`;

export const numberValue = styled.span`
    white-space: nowrap;
    font-size: var(--font-size-text-metric-secondary, 20px);
    font-weight: var(--font-weight-bold);
    line-height: 1;
`;

export const blockValue = styled.span`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    width: 100%;
    text-align: center;
    word-break: break-word;
    font-size: var(--font-size-text-metric-secondary, 20px);
    font-weight: var(--font-weight-bold);
    line-height: 1;
`;

export const label = styled.span`
    flex: none;
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-regular);
    line-height: 1.17;
`;
